import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { auth, db } from '../FirebaseComp/firebase';
import { doc, setDoc } from 'firebase/firestore';
import './signup.css';

function SignUp() {
  const [name, setName] = useState('');
  // const [country, setCountry] = useState('');
  const [contactNo, setContactNo] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSignup = async (e) => {
    e.preventDefault();
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const userId = userCredential.user.uid;

      // Save user to Firestore as a normal user
      await setDoc(doc(db, 'users', userId), { name, contactNo, email, role: 'user' });
      navigate('/signin'); // Redirect to login page
    } catch (err) {
      setError('Error creating account. Please try again.');
    }
  };

  return (

    <>



    <div className="form-container">
      <h2>Sign Up</h2>
      {error && <p className="error-message">{error}</p>}
      <form onSubmit={handleSignup}>
      <input
          type="name"
          placeholder="Enter your Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
          {/* <input
          type="Country"
          placeholder="Enter your Country / Region"
          value={country}
          onChange={(e) => setCountry(e.target.value)}
          required
        /> */}

        <input
          type="tel"
          placeholder="Enter your Contact No"
          value={contactNo}
          onChange={(e) => setContactNo(e.target.value)}
          required
        />

        <input
          type="email"
          placeholder="Enter your Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Create your Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <button type="submit" className="form-btn">Sign Up</button>
      </form>
    </div>
    </>
  );
}

export default SignUp;
